export class LoginTokenModel {
    UserEmail: string;
    TokenType: number;
    Token: string;
    Origin: number;

    constructor() {
        this.UserEmail = '';
        this.TokenType = 0;
        this.Token = '';
        this.Origin = 1;
    }
  }
